<!--
 * @Author: fengqianhui
 * @Date: 2024-01-10 11:47:54
 * @LastEditors: fengqianhui fengqianhui@wedobest.com.cn
 * @LastEditTime: 2024-05-21 17:02:21
 * @FilePath: \landingpage\src\views\build\index.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<script setup lang="ts">
import BasicInfo from './components/BasicInfo.vue';
import FunctionArea from './components/FunctionArea.vue';
import BadgeArea from './components/BadgeArea.vue';
import { buildResult } from './hooks/useResult';
import { toggleMark } from '@/api/download';
import { useOriginDataStore } from '@/stores/originDataStore';
import ButtonGroup from './components/ButtonGroup.vue';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';

const route = useRoute();
const originData = computed(() => store.data);
const store = useOriginDataStore();
const { isMobile } = buildResult();
onMounted(async () => {
  const id = route.params.id as string;
  await store.fetchOriginData(id);
  nextTick(() => {
    document.title = originData?.value?.productName || '';
    const iconLink = (document.querySelector("link[rel='icon']") || document.getElementsByTagName('link')[0]) as HTMLLinkElement | null;
    if (iconLink) {
      iconLink.href = originData?.value?.iconUrl ?? '';
    }
  });
});

async function handleToggle() {
  const id = route.params.id as string;
  if (!id) {
    return;
  }
  message.loading('加载中...', 0);
  const res = await toggleMark({ taskId: id, action: originData.value?.manualMark == 0 ? 1 : 0 });
  message.destroy();
  // 更新状态
  if (res?.code == '200' || res?.code == '0000') {
    store.fetchOriginData(id);
  }
}
</script>

<template>
  <div class="outer-box">
    <BasicInfo @toggleStar="handleToggle"></BasicInfo>
    <div class="bottom-wrap">
      <FunctionArea class="left-area"></FunctionArea>
      <BadgeArea class="right-area" v-show="!isMobile && originData?.platform != 3"></BadgeArea>
    </div>
    <ButtonGroup v-if="isMobile"></ButtonGroup>
  </div>
</template>

<style scoped lang="less">
.outer-box {
  width: 1408px;
  min-height: calc(100vh - 40px);
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 1);
  margin: 20px auto;
  padding: 20px;
  overflow-y: auto;
  box-sizing: border-box;
  .bottom-wrap {
    display: flex;
    justify-content: flex-start;
    width: 1200px;
    margin: 0 auto;
    margin-top: 65px;
    height: 520px;
    .left-area {
      flex: 1;
      width: 100%;
      height: 100%;
      border-radius: 2px;
    }
    .right-area {
      width: 175px;
      height: 100%;
      border-radius: 2px;
      box-sizing: border-box;
      background: rgba(248, 249, 250, 1);
      margin-left: 16px;
      border-radius: 2px;
    }
  }
}
</style>
<style scoped lang="less">
@media (max-width: 550px) {
  .mobile-viewport div.outer-box {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    margin: 0;
    padding: 0;
    .bottom-wrap {
      width: 100vw;
      height: calc(100vh - 300px);
      margin-top: 35px;
      .left-area {
        overflow-x: hidden;
      }
    }
  }
}
</style>
